import { mapper } from "utils/mapping";
import { ReactComponent as Fall } from "assets/maintenance_plan/fall.svg";

export const icons = mapper({ fall: Fall }, Fall);
